module.exports = __webpack_public_path__ + "img/H2O.b0672cc1.png";